import { useEffect } from 'react';

import { usePreferencesStore } from '@/core/store/preferences.store';
import { applyThemeForSetting } from '@/core/utils/theme';
import { syncNativeStatusBar } from '@/core/lib/native-status-bar';

/**
 * Hook that applies the persisted theme preference on app load and
 * listens for OS-level dark/light mode changes when set to "system".
 */
export function useThemeBootstrap() {
  const themeSetting = usePreferencesStore((state) => state.themeSetting);
  const hydrated = usePreferencesStore((state) => state.hydrated);

  useEffect(() => {
    if (!hydrated) return;
    applyThemeForSetting(themeSetting);
    void syncNativeStatusBar();

    if (themeSetting !== 'system' || typeof window === 'undefined') return;

    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = () => {
      applyThemeForSetting('system');
      void syncNativeStatusBar();
    };
    media.addEventListener('change', handleChange);
    return () => media.removeEventListener('change', handleChange);
  }, [themeSetting, hydrated]);
}
